import { httpsCallable } from "firebase/functions";
import { getFirebaseFunctions } from "../firebase.ts";
import { type User } from "./userModel.ts";

interface Request {}

interface Response {
  success: boolean;
  user: User;
}

export const swrKey = "getUser";

export const userFetcher = async () => {
  const functions = getFirebaseFunctions();
  const getUserFunction = httpsCallable<Request, Response, object>(
    functions,
    swrKey,
  );
  const res = await getUserFunction();
  return res.data.user;
};
